import React from "react";
import { useNavigate } from "react-router-dom";

export default function Header({
  title,
  disableBack,
  isUsingFragment,
  fragmentHistory,
  setFragmentHistory,
  setFragment,
}) {
  // navigate
  const navigate = useNavigate();

  return (
    <div className="w-full px-5 py-4 bg-white fixed top-0 shadow-md z-50">
      <div className="flex items-center">
        {!disableBack && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              if (isUsingFragment) {
                let history = fragmentHistory.slice(0, -1);
                setFragmentHistory(history);
                setFragment(history[history.length - 1]);
              } else {
                navigate(-1);
              }
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M9.707 16.707a1 1 0 01-1.414 0l-6-6a1 1 0 010-1.414l6-6a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l4.293 4.293a1 1 0 010 1.414z"
                clipRule="evenodd"
              />
            </svg>
          </button>
        )}

        <h2 className="flex-1 text-gray-700 text-center font-bold">{title}</h2>
      </div>
    </div>
  );
}
